const JOB_FORMATS = [
    { value: 'catchmentTrend', label: 'Tendance captage', type: 'calcul' },
    { value: 'wsAdesPiezo', label: 'Web Service ADES piézométrie', type: 'import' },
    { value: 'wsAdesQualito', label: 'Web Service ADES qualité', type: 'import' },
    { value: 'importQuesu', label: 'import QUESU', type: 'import' },
    { value: 'importQesoutPiezo', label: 'import QESOUT Piezo', type: 'import' },
    { value: 'importQesoutQuality', label: 'import QESOUT Qualité', type: 'import' },
    { value: 'lowWater', label: 'Étiages ONDE', type: 'import' },
    { value: 'importEdilabo', label: 'EDILABO', type: 'import' },
    { value: 'importEdilaboDAI', label: 'EDILABO DAI', type: 'import' },
    { value: 'ddassdistri', label: 'Echanges DDASS-Distributeurs', type: 'import' },
    { value: 'importPiveau', label: 'PIVEAU', type: 'import' },
    { value: 'importRsde', label: 'importRsde', type: 'import' },
    { value: 'synop', label: 'SYNOP', type: 'import' },
    { value: 'selfControl', label: 'Auto contrôle', type: 'import' },
    { value: 'ligura', label: 'LIGURA', type: 'import' },
    { value: 'hydro', label: 'HYDRO', type: 'import' },
    { value: 'tidegauge', label: 'Marégraphe', type: 'import' },
    { value: 'oceanogram', label: 'Océanogramme', type: 'import' },
    { value: 'surfaceQualitometer', label: 'Qualitomètre de surface', type: 'import' },
    { value: 'vigicrues', label: 'Vigicrues', type: 'import' },
    { value: 'csvAll', label: 'CSV générique', type: 'import' },
    { value: 'synchro_city', label: 'Centre des communes via l\'INSEE', type: 'import' },
    { value: 'infoTerreBoreholesDepartment', label: 'InfoTerre', type: 'import' },
    { value: 'seba', label: 'SEBA', type: 'import' },
    { value: 'paratronicLNSXML', label: 'Paratronic LNS XML', type: 'import' },
    { value: 'MISfiles', label: 'Fichiers .MIS', type: 'import' },
    { value: 'processFileIAEau', label: 'Script IAEau', type: 'calcul' },
    { value: 'cemagref', label: 'CEMAGREF', type: 'import' },
    { value: 'HUBEAUpiezo', label: 'Hubeau piézométrie', type: 'import' },
    { value: 'HUBEAUquality', label: 'HubEau qualité', type: 'import' },
    { value: 'hydrobio', label: 'Import Hydrobio', type: 'import' },
    { value: 'importOmnidia', label: 'OMNIDIA', type: 'import' },
    { value: 'quadrige', label: 'Import Quadrige', type: 'import' },
    { value: 'distantFtp', label: 'Télécharger via FTP', type: 'import' },
    { value: 'uploadFtpManually', label: 'Transfert manuel sur le FTP (Dépôt de fichiers)', type: 'import' },
    { value: 'pluvioArea', label: 'Données pluvio d\'emprise', type: 'import' },
    { value: 'scriptSSH', label: 'Lancer un script ssh', type: 'import' },
    { value: 'era5', label: 'ERA5', type: 'import' },
    { value: 'mfObs', label: 'Météo France', type: 'import' },
    { value: 'mfRadar', label: 'Météo France (Données SAFRAN)', type: 'import' },
    { value: 'sieauInstance', label: 'Instance SIEau', type: 'import' },
    { value: 'mailUploadToFtp', label: 'Fichiers par email', type: 'import' },
    { value: 'veoliaPortalToFtp', label: 'Portail Veolia', type: 'import' },
    { value: 'tapWater', label: 'Eau du robinet', type: 'import' },
    { value: 'quesoutAck', label: 'QESOUT Acquittement', type: 'export' },
    { value: 'quesout', label: 'Export QESOUT PIEZO', type: 'export' },
    { value: 'qesoutQualito', label: 'Export QESOUT Qualité', type: 'export' },
    { value: 'exportQuesu', label: 'Export QUESU Qualité', type: 'export' },
    { value: 'hydroportailExport', label: 'Export HydroPortail', type: 'export' },
    { value: 'edilaboExport', label: 'EDILABO DAI', type: 'export' },
    { value: 'qualityResearchStats', label: 'Recherche qualité', type: 'export' },
    { value: 'postFacebook', label: 'Publication facebook', type: 'export' },
    { value: 'exportTmpScheduled', label: 'Export de masse programmé', type: 'export' },
    { value: 'modelCalculationManually', label: 'Calcul de modèles', type: 'calcul' },
    { value: 'piezoIndicatorsCalculation', label: 'Calcul d\'indicateurs piézo', type: 'calcul' },
    { value: 'qualityPostControl', label: 'Post contrôle qualité', type: 'controle' },
    { value: 'alertPluvio', label: 'Alerte pluviométrique', type: 'alert' },
    { value: 'alertHydro', label: 'Alerte hydrométrique', type: 'alert' },
    { value: 'alertPiezo', label: 'Alerte piezométrique', type: 'alert' },
    { value: 'outlierQuality', label: 'Donnée aberrante qualité', type: 'alert' },
    { value: 'importMateriel', label: 'importMateriel', type: 'import' },
    { value: 'Veolia', label: 'Veolia', type: 'import' },
    { value: 'importSiapLab', label: 'SiapLab', type: 'import' },
    { value: 'veoliaVolume', label: 'veoliaVolume', type: 'import' },
    { value: 'aquadbSelection', label: 'Séléction AquaDB', type: 'import' },
    { value: 'saurVolume', label: 'saurVolume', type: 'import' },
    { value: 'calypso', label: 'Calypso', type: 'import' },
    { value: 'weatherMeasures', label: 'Weather Measures', type: 'import' },
    { value: 'edilaboRai', label: 'EDILABO RAI', type: 'export' },
    { value: 'activity', label: 'Activités', type: 'import' },
    { value: 'establishment', label: 'Établissement', type: 'import' },
    { value: 'jobPurgeMateriel', label: 'Purger le matériel', type: 'purge' },
    { value: 'jobPurgeQuality', label: 'Purger la qualité', type: 'purge' },
    { value: 'purgeStation', label: 'Purger la station', type: 'purge' },
    { value: 'contributorSynchro', label: 'Synchro des Intervenants', type: 'import' },
    { value: 'importEtatEco', label: 'intégration Etat Ecologique', type: 'import' },
    { value: 'newslettersGeneration', label: 'Génération de bulletin', type: 'cms' },
    { value: 'CalculSeee', label: 'CalculSeee', type: 'calcul' },
    { value: 'materielCompta', label: 'Import comptable de matériel', type: 'import' },
    { value: 'ArchiveJob', label: 'ArchiveJob', type: 'archive' },
    { value: 'bathingWater', label: 'Eaux de baignade', type: 'import' },
    { value: 'alerteClimatic', label: 'Alerte climatique', type: 'alert' },
    { value: 'perimetersImport', label: 'Import de périmètres', type: 'import' },
]

const getJobTypeLabel = jobType => JOB_FORMATS.find(f => f.value === jobType)?.label ?? jobType

export { JOB_FORMATS, getJobTypeLabel }
